import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

export interface AutocompleteOption {
  label: string;
  value: string;
  id?: string | number;
}

@Component({
  selector: 'select-autocomplete',
  templateUrl: './select-autocomplete.component.html',
  styleUrls: ['./select-autocomplete.component.scss']
})
@UntilDestroy()
export class SelectAutocomplete implements OnInit {
  @Input() control: FormControl;
  @Input() options$: Observable<string[] | AutocompleteOption[]>;
  @Input() placeholder: string = '';

  isObjectArray = false;

  constructor() { }

  ngOnInit(): void {
    // Detect if options are objects or strings
    this.options$
      .pipe(untilDestroyed(this))
      .subscribe((options) => {
        if (options && options.length > 0) {
          this.isObjectArray = typeof options[0] === 'object';
        }
      });
  }
}
